var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sermon-table',{attrs:{"in-group":_vm.inGroup,"in-series":_vm.inSeries,"show-search-bar":false,"show-series":false,"show-scripture":false,"show-direct":true},domProps:{"sort":{ date: 'asc' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }